import axios from 'axios';
import { Message } from 'element-ui';
import { getToken, setToken } from '@/utils/auth';

// Create axios instance
const service = axios.create({
  // baseURL: 'http://210.243.176.186/_rpc/v3/rpc_json.php',
  headers: { "Content-Type": "multipart/form-data" },
  timeout: 10000
})
// const service = axios.create();

const defaultBody = {
  '__ds': 'center',
  '__dbid': '0',
  '__ds_origin': 'site',
  '__dbid_origin': '2'
}
// Request intercepter
service.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + getToken(); // Set JWT token
    }
    if (config.method === 'post') {
        // config.baseURL = 'https://aew.cyberhood.net/_rpc/v3/rpc_json.php'  //國尊的模擬環境資料
       config.baseURL = 'https://aew.moe.edu.tw/_rpc/v3/rpc_json.php'   //正式主機上的資料
        // config.baseURL = "/_rpc/v3/rpc_json.php"  //放到正式主機上要用這個網址
      const path = config.data.get('__rpcname')
      let body = ['GrantUserLogin', 'GrantApplicationResultUpload', 'CourseUserLogin'].some(e => path.includes(e))
        ? { '__ds': 'center', '__dbid': '0' }
        : path.includes('ApplicationUpdate')
        ? { '__ds': 'site', '__dbid': '2' }
        : defaultBody
      Object.keys(body).forEach(k => {
        const value = body[k]
        if (!config.data.has(k)) {
          config.data.append(k, value)
        }
      })
    }
    return config;
  },
  error => {
    console.error(error); // for debug
    Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    if (response.headers.authorization) {
      setToken(response.headers.authorization);
      response.data.token = response.headers.authorization;
    }

    return response.data;
  },
  error => {
    console.warn({ error })
    let message = error.message;
    if (error.response.data && error.response.data.errors) {
      // message = error.response.data.errors;
    } else if (error.response.data && error.response.data.error) {
      // message = error.response.data.error;
    } else if (error.response.status === 401) {
      // message = '操作逾時，請重新整理頁面 或 重新登入。';
    }

    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  },
);

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js